namespace $ {

	export class $shm_hitalama_map_history_storage_indices extends $giper_baza_dict_to(
		$giper_baza_atom_link.to( ()=> $shm_hitalama_map_history_storage_index ),
	) {}

}
